module.exports = __webpack_public_path__ + "static/img/jigou-shenyang-bottom.6566a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shenyang-bottom.png
// module id = l5zc
// module chunks = 2